import { useMutation } from '@tanstack/react-query';
import { useSdk } from '../../sdk';
import { useAuth } from '../../providers/authentication-provider';
import { useQuery } from '@apollo/client';
import { GET_CONTACT_BY_ID } from '@zaplify/graphql';
import { useToast } from '@shadcn/ui/hooks/use-toast';

export const useNoteMutations = ({ contactId }: { contactId: string }) => {
    const { toast } = useToast();
    const {
        notes: { createNote: createNoteMutation, deleteNote: deleteNoteMutation },
        trackers: { getLinkedinCursorToSyncFrom },
    } = useSdk();
    const { authState } = useAuth();
    const { data: contact } = useQuery(GET_CONTACT_BY_ID, {
        variables: { id: contactId },
    });

    // TODO: add refetchNotes on success
    const { mutateAsync: createNote } = useMutation(createNoteMutation({ onSuccess: () => {} }));
    const { mutateAsync: deleteNote } = useMutation(deleteNoteMutation({ onSuccess: () => {} }));

    const addNote = async ({ content, title }: { content: string; title?: string }) => {
        try {
            await createNote({
                userId: authState.user.id,
                prospectId: contact?.Contacts_by_pk?.prospectId,
                content,
                title: title || '',
            });
        } catch (error) {
            console.error(`addNote | error: ${JSON.stringify(error)}`);
            toast({
                title: 'An error occurred while adding the note. Please try again.',
                variant: 'error',
            });
        }
    };

    const removeNote = async ({ noteId }: { noteId: string }) => {
        try {
            await deleteNote({ noteId });
            toast({
                title: 'Note removed successfully',
                variant: 'success',
            });
        } catch (error) {
            console.error(`deleteNote | error: ${JSON.stringify(error)}`);
            toast({
                title: 'An error occurred while removing the note. Please try again.',
                variant: 'error',
            });
        }
    };

    return { addNote, removeNote };
};
